import { Colors, Lightning } from '@lightningjs/sdk';
import Button from 'components/common/buttons/Button';
import { getFontFaceFromStyle } from 'support/textUtils';
import { translate } from 'support/translate';

export interface SignOutButtonTemplateSpec
  extends Lightning.Component.TemplateSpec {
  Button: typeof Button;
}

const SECTION_WIDTH = 640;
const BUTTON_HEIGHT = 65;
const BUTTON_FONT_SIZE = 18;

export default class SignOutButton
  extends Lightning.Component<SignOutButtonTemplateSpec>
  implements
    Lightning.Component.ImplementTemplateSpec<SignOutButtonTemplateSpec>
{
  static override _template(): Lightning.Component.Template<SignOutButtonTemplateSpec> {
    return {
      Button: {
        type: Button,
        height: BUTTON_HEIGHT,
        minWidth: SECTION_WIDTH,
        label: translate('settings.LoggedInProfile.SignOutButton'),
        title: translate('settings.LoggedInProfile.SignOutButton'),
        fontSize: BUTTON_FONT_SIZE,
        fontFace: getFontFaceFromStyle('regular'),
        radius: 5,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          stroke: 2,
          strokeColor: Colors('white').get(),
          radius: 5,
        },
        backgroundColor: {
          focused: Colors('white').get(),
          unfocused: Colors('alternateBackground').get(),
        },
        fontColor: {
          focused: Colors('black').get(),
          unfocused: Colors('text').get(),
        },
        passSignals: {
          $onHover: true,
          $signOut: true,
        },
        action: '$signOut',
      },
    };
  }
}
